import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-info-layout',
  templateUrl: './info-layout-component.html',
  styleUrls: ['../../app.component.scss']
})
export class InfoLayoutComponent implements OnInit {

  //public isCollapsed = true;

  constructor(
    private router: Router,
    private translateService:TranslateService
  ) { }

  ngOnInit() { }

  useLanguage(language: string) {
    this.translateService.use(language);

  }
  getLanguange()
  {
    return this.translateService.currentLang;
  }
  status: boolean = false;
  clickEvent(){
    this.status = !this.status;   
  }
  onClickedOutside(e: Event) {
    this.status = false;

  }
}
